import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ErrorBoundaryFallbackComponent from "./ErrorBoundaryFallbackComponent";

class ErrorBoundary extends Component {
  static defaultProps = {
    FallbackComponent: ErrorBoundaryFallbackComponent
  };

  state = {
    error: null,
    info: null
  };

  componentDidMount() {
    this.unlisten = this.props.history.listen((location, action) => {
      if (this.state.error) window.location.reload(false);
    });
  }

  componentWillUnmount() {
    this.unlisten();
  }

  componentDidCatch(error, info) {
    const { onError } = this.props;

    if (typeof onError === "function") {
      try {
        /* istanbul ignore next: Ignoring ternary; can’t reproduce missing info in test environment. */
        onError.call(this, error, info ? info.componentStack : "");
      } catch (ignoredError) {}
    }

    this.setState({ error, info, location: this.props.history.location });
  }

  render() {
    const { children, FallbackComponent } = this.props;
    const { error, info } = this.state;

    if (error !== null) {
      return (
        <FallbackComponent
          componentStack={
            // istanbul ignore next: Ignoring ternary; can’t reproduce missing info in test environment.
            info ? info.componentStack : ""
          }
          error={error}
        />
      );
    }

    return children || null;
  }
}

export default withRouter(ErrorBoundary);
